export default function StoreFieldInSession(options?: {
  lateKeyInitilization?: boolean;
  type?: 'Set' | 'Map';

  serialize?: (value: any) => any;
  deserialize?: (value: any) => any;

  /**
   * Mobx reaction to the field change.
   * When filed changes, this function will be called with the new value.
   * And the new value will be saved in the session.
   *
   * @param value
   */
  reactOn?(value: any): any;
}) {
  return function FieldDecorator<C, V>(
    target: any,
    ctx: ClassFieldDecoratorContext<C, V>
  ) {
    const fieldName = ctx.name.toString();

    return function (this: any, value: any) {
      if (this.__sessionFields === undefined) {
        this.__sessionFields = new Map();
      }

      this.__sessionFields.set(fieldName, {
        value,
        key: `${this.constructor.name}.${fieldName}`,
        lateKeyInitilization: options?.lateKeyInitilization,
        type: options?.type,
        serialize: options?.serialize,
        deserialize: options?.deserialize,
        reactOn: options?.reactOn
      });

      return value;
    };
  };
}
